export default "__VITE_ASSET__b294b173__"